export default function countdownClock() {
  
  function init() {
    $('#countdown-clock').countdownClock({
      date: '2018-10-04',
      showYears: false,
      showSeconds: false
    });
  }
  
  if($('#countdown-clock').length > 0) {
    $( document ).ready(function() {
      init()
    });
  }
  
}


// WEBPACK FOOTER //
// ./src/assets/js/countdown-clock.js